import { Locale } from "@/lib/i18n";

type ToolUiCopy = {
  loadingPdfTool: string;
  loadingPdfEditor: string;
  loadingVectorizer: string;
  toolComingSoonTitle: string;
  toolComingSoonBodyPrefix: string;
  toolComingSoonBodySuffix: string;
  copy: string;
  clear: string;
  cancel: string;
  remove: string;
  preview: string;
  inputText: string;
  output: string;
  generatedText: string;
  copyToClipboard: string;
  generate: string;
  convert: string;
  from: string;
  to: string;
  autoDetect: string;
  dropYourImageHere: string;
  orClickToBrowse: string;
  converting: string;
  convertTo: string;
  pleaseSelectImageFile: string;
  numberOfParagraphs: string;
  wordsPerParagraph: string;
  words: string;
  characters: string;
  sentences: string;
  paragraphs: string;
  noSpaces: string;
  typeOrPasteTextHere: string;
  enterYourTextHere: string;
  resizeSettings: string;
  widthPx: string;
  heightPx: string;
  maintainAspectRatio: string;
  quality: string;
  downloadResizedImage: string;
  uploadDifferentImage: string;
  clickToUploadImage: string;
  supportsJpgPng: string;
  compressionQuality: string;
  maximumCompression: string;
  minimumCompression: string;
  compressing: string;
  compressionSuccessful: string;
  readyForDownload: string;
  originalSize: string;
  compressedSize: string;
  totalReduction: string;
  originalPreview: string;
  compressedPreview: string;
  downloadCompressedImage: string;
  aspectRatio: string;
  dimensions: string;
  xPosition: string;
  yPosition: string;
  cropAndDownload: string;
  cancelOrNewImage: string;
  cropArea: string;
  free: string;
  square: string;
  uploadPdfToEdit: string;
  clickToSelectOrDragPdfHere: string;
  redirectingToPdfEditor: string;
};

const copy: Record<Locale, ToolUiCopy> = {
  en: {
    loadingPdfTool: "Loading PDF tool...",
    loadingPdfEditor: "Loading PDF editor...",
    loadingVectorizer: "Loading vectorizer...",
    toolComingSoonTitle: "Tool Coming Soon",
    toolComingSoonBodyPrefix: "We are currently building the logic for",
    toolComingSoonBodySuffix: "Please check back later.",
    copy: "Copy",
    clear: "Clear",
    cancel: "Cancel",
    remove: "Remove",
    preview: "Preview",
    inputText: "Input Text",
    output: "Output",
    generatedText: "Generated Text",
    copyToClipboard: "Copy to clipboard",
    generate: "Generate",
    convert: "Convert",
    from: "From",
    to: "To",
    autoDetect: "Auto-detect",
    dropYourImageHere: "Drop your image here",
    orClickToBrowse: "or click to browse",
    converting: "Converting...",
    convertTo: "Convert to",
    pleaseSelectImageFile: "Please select an image file.",
    numberOfParagraphs: "Number of Paragraphs",
    wordsPerParagraph: "Words per Paragraph",
    words: "Words",
    characters: "Characters",
    sentences: "Sentences",
    paragraphs: "Paragraphs",
    noSpaces: "No Spaces",
    typeOrPasteTextHere: "Type or paste your text here...",
    enterYourTextHere: "Enter your text here...",
    resizeSettings: "Resize Settings",
    widthPx: "Width (px)",
    heightPx: "Height (px)",
    maintainAspectRatio: "Maintain aspect ratio",
    quality: "Quality",
    downloadResizedImage: "Download Resized Image",
    uploadDifferentImage: "Upload different image",
    clickToUploadImage: "Click to upload image",
    supportsJpgPng: "Supports JPG, PNG",
    compressionQuality: "Compression Quality",
    maximumCompression: "Maximum Compression (Low Quality)",
    minimumCompression: "Minimum Compression (High Quality)",
    compressing: "Compressing...",
    compressionSuccessful: "Compression Successful!",
    readyForDownload: "Your image is ready for download.",
    originalSize: "Original Size",
    compressedSize: "Compressed Size",
    totalReduction: "Total Reduction",
    originalPreview: "Original Preview",
    compressedPreview: "Compressed Preview",
    downloadCompressedImage: "Download Compressed Image",
    aspectRatio: "Aspect Ratio",
    dimensions: "Dimensions",
    xPosition: "X Position",
    yPosition: "Y Position",
    cropAndDownload: "Crop & Download",
    cancelOrNewImage: "Cancel / New Image",
    cropArea: "Crop area",
    free: "Free",
    square: "Square",
    uploadPdfToEdit: "Upload PDF to Edit",
    clickToSelectOrDragPdfHere: "Click to select or drag PDF here",
    redirectingToPdfEditor: "Redirecting to PDF Editor...",
  },
  id: {
    loadingPdfTool: "Memuat tool PDF...",
    loadingPdfEditor: "Memuat editor PDF...",
    loadingVectorizer: "Memuat vectorizer...",
    toolComingSoonTitle: "Tool Segera Hadir",
    toolComingSoonBodyPrefix: "Kami sedang menyiapkan logic untuk",
    toolComingSoonBodySuffix: "Silakan cek lagi nanti.",
    copy: "Salin",
    clear: "Hapus",
    cancel: "Batal",
    remove: "Hapus",
    preview: "Preview",
    inputText: "Teks Input",
    output: "Output",
    generatedText: "Teks Hasil",
    copyToClipboard: "Salin ke clipboard",
    generate: "Buat",
    convert: "Konversi",
    from: "Dari",
    to: "Ke",
    autoDetect: "Deteksi otomatis",
    dropYourImageHere: "Taruh gambar kamu di sini",
    orClickToBrowse: "atau klik untuk memilih",
    converting: "Sedang mengonversi...",
    convertTo: "Konversi ke",
    pleaseSelectImageFile: "Silakan pilih file gambar.",
    numberOfParagraphs: "Jumlah Paragraf",
    wordsPerParagraph: "Kata per Paragraf",
    words: "Kata",
    characters: "Karakter",
    sentences: "Kalimat",
    paragraphs: "Paragraf",
    noSpaces: "Tanpa Spasi",
    typeOrPasteTextHere: "Tulis atau tempel teks kamu di sini...",
    enterYourTextHere: "Masukkan teks kamu di sini...",
    resizeSettings: "Pengaturan Resize",
    widthPx: "Lebar (px)",
    heightPx: "Tinggi (px)",
    maintainAspectRatio: "Pertahankan rasio aspek",
    quality: "Kualitas",
    downloadResizedImage: "Unduh Gambar Hasil Resize",
    uploadDifferentImage: "Upload gambar lain",
    clickToUploadImage: "Klik untuk upload gambar",
    supportsJpgPng: "Mendukung JPG, PNG",
    compressionQuality: "Kualitas Kompresi",
    maximumCompression: "Kompresi Maksimal (Kualitas Rendah)",
    minimumCompression: "Kompresi Minimum (Kualitas Tinggi)",
    compressing: "Sedang mengompres...",
    compressionSuccessful: "Kompresi Berhasil!",
    readyForDownload: "Gambar kamu siap diunduh.",
    originalSize: "Ukuran Asli",
    compressedSize: "Ukuran Setelah Kompres",
    totalReduction: "Total Pengurangan",
    originalPreview: "Preview Asli",
    compressedPreview: "Preview Hasil Kompres",
    downloadCompressedImage: "Unduh Gambar Terkompres",
    aspectRatio: "Rasio Aspek",
    dimensions: "Dimensi",
    xPosition: "Posisi X",
    yPosition: "Posisi Y",
    cropAndDownload: "Crop & Unduh",
    cancelOrNewImage: "Batal / Gambar Baru",
    cropArea: "Area crop",
    free: "Bebas",
    square: "Persegi",
    uploadPdfToEdit: "Upload PDF untuk Diedit",
    clickToSelectOrDragPdfHere: "Klik untuk memilih atau tarik PDF ke sini",
    redirectingToPdfEditor: "Mengalihkan ke Editor PDF...",
  },
  vi: {
    loadingPdfTool: "Đang tải công cụ PDF...",
    loadingPdfEditor: "Đang tải trình chỉnh sửa PDF...",
    loadingVectorizer: "Đang tải vectorizer...",
    toolComingSoonTitle: "Công Cụ Sắp Có",
    toolComingSoonBodyPrefix: "Chúng tôi đang xây dựng logic cho",
    toolComingSoonBodySuffix: "Vui lòng quay lại sau.",
    copy: "Sao chép",
    clear: "Xóa",
    cancel: "Hủy",
    remove: "Xóa",
    preview: "Xem trước",
    inputText: "Văn bản đầu vào",
    output: "Kết quả",
    generatedText: "Văn bản đã tạo",
    copyToClipboard: "Sao chép vào clipboard",
    generate: "Tạo",
    convert: "Chuyển đổi",
    from: "Từ",
    to: "Sang",
    autoDetect: "Tự động nhận diện",
    dropYourImageHere: "Thả ảnh của bạn vào đây",
    orClickToBrowse: "hoặc bấm để chọn",
    converting: "Đang chuyển đổi...",
    convertTo: "Chuyển sang",
    pleaseSelectImageFile: "Vui lòng chọn tệp hình ảnh.",
    numberOfParagraphs: "Số đoạn",
    wordsPerParagraph: "Số từ mỗi đoạn",
    words: "Từ",
    characters: "Ký tự",
    sentences: "Câu",
    paragraphs: "Đoạn",
    noSpaces: "Không khoảng trắng",
    typeOrPasteTextHere: "Nhập hoặc dán văn bản tại đây...",
    enterYourTextHere: "Nhập văn bản của bạn tại đây...",
    resizeSettings: "Cài đặt đổi kích thước",
    widthPx: "Chiều rộng (px)",
    heightPx: "Chiều cao (px)",
    maintainAspectRatio: "Giữ tỷ lệ khung hình",
    quality: "Chất lượng",
    downloadResizedImage: "Tải ảnh đã đổi kích thước",
    uploadDifferentImage: "Tải ảnh khác",
    clickToUploadImage: "Bấm để tải ảnh lên",
    supportsJpgPng: "Hỗ trợ JPG, PNG",
    compressionQuality: "Chất lượng nén",
    maximumCompression: "Nén tối đa (chất lượng thấp)",
    minimumCompression: "Nén tối thiểu (chất lượng cao)",
    compressing: "Đang nén...",
    compressionSuccessful: "Nén thành công!",
    readyForDownload: "Ảnh của bạn đã sẵn sàng để tải xuống.",
    originalSize: "Kích thước gốc",
    compressedSize: "Kích thước sau nén",
    totalReduction: "Tổng mức giảm",
    originalPreview: "Xem trước gốc",
    compressedPreview: "Xem trước sau nén",
    downloadCompressedImage: "Tải ảnh đã nén",
    aspectRatio: "Tỷ lệ khung hình",
    dimensions: "Kích thước",
    xPosition: "Vị trí X",
    yPosition: "Vị trí Y",
    cropAndDownload: "Cắt & Tải xuống",
    cancelOrNewImage: "Hủy / Ảnh mới",
    cropArea: "Vùng cắt",
    free: "Tự do",
    square: "Vuông",
    uploadPdfToEdit: "Tải PDF để chỉnh sửa",
    clickToSelectOrDragPdfHere: "Bấm để chọn hoặc kéo PDF vào đây",
    redirectingToPdfEditor: "Đang chuyển đến trình chỉnh sửa PDF...",
  },
  cs: {
    loadingPdfTool: "Načítá se PDF nástroj...",
    loadingPdfEditor: "Načítá se PDF editor...",
    loadingVectorizer: "Načítá se vectorizer...",
    toolComingSoonTitle: "Nástroj Již Brzy",
    toolComingSoonBodyPrefix: "Právě připravujeme logiku pro",
    toolComingSoonBodySuffix: "Zkuste to prosím později.",
    copy: "Kopírovat",
    clear: "Vyčistit",
    cancel: "Zrušit",
    remove: "Odstranit",
    preview: "Náhled",
    inputText: "Vstupní text",
    output: "Výstup",
    generatedText: "Vygenerovaný text",
    copyToClipboard: "Kopírovat do schránky",
    generate: "Vygenerovat",
    convert: "Převést",
    from: "Z",
    to: "Na",
    autoDetect: "Automaticky rozpoznat",
    dropYourImageHere: "Přetáhněte obrázek sem",
    orClickToBrowse: "nebo klikněte pro výběr",
    converting: "Převádí se...",
    convertTo: "Převést na",
    pleaseSelectImageFile: "Vyberte prosím obrázek.",
    numberOfParagraphs: "Počet odstavců",
    wordsPerParagraph: "Slov na odstavec",
    words: "Slova",
    characters: "Znaky",
    sentences: "Věty",
    paragraphs: "Odstavce",
    noSpaces: "Bez mezer",
    typeOrPasteTextHere: "Pište nebo vložte text sem...",
    enterYourTextHere: "Zadejte text sem...",
    resizeSettings: "Nastavení změny velikosti",
    widthPx: "Šířka (px)",
    heightPx: "Výška (px)",
    maintainAspectRatio: "Zachovat poměr stran",
    quality: "Kvalita",
    downloadResizedImage: "Stáhnout upravený obrázek",
    uploadDifferentImage: "Nahrát jiný obrázek",
    clickToUploadImage: "Klikněte pro nahrání obrázku",
    supportsJpgPng: "Podporuje JPG, PNG",
    compressionQuality: "Kvalita komprese",
    maximumCompression: "Maximální komprese (nízká kvalita)",
    minimumCompression: "Minimální komprese (vysoká kvalita)",
    compressing: "Komprimuje se...",
    compressionSuccessful: "Komprese úspěšná!",
    readyForDownload: "Váš obrázek je připraven ke stažení.",
    originalSize: "Původní velikost",
    compressedSize: "Komprimovaná velikost",
    totalReduction: "Celkové zmenšení",
    originalPreview: "Původní náhled",
    compressedPreview: "Komprimovaný náhled",
    downloadCompressedImage: "Stáhnout komprimovaný obrázek",
    aspectRatio: "Poměr stran",
    dimensions: "Rozměry",
    xPosition: "Pozice X",
    yPosition: "Pozice Y",
    cropAndDownload: "Oříznout a stáhnout",
    cancelOrNewImage: "Zrušit / Nový obrázek",
    cropArea: "Oblast ořezu",
    free: "Volné",
    square: "Čtverec",
    uploadPdfToEdit: "Nahrát PDF k úpravě",
    clickToSelectOrDragPdfHere: "Klikněte pro výběr nebo sem přetáhněte PDF",
    redirectingToPdfEditor: "Přesměrování do PDF editoru...",
  },
  es: {
    loadingPdfTool: "Cargando herramienta PDF...",
    loadingPdfEditor: "Cargando editor PDF...",
    loadingVectorizer: "Cargando vectorizador...",
    toolComingSoonTitle: "Herramienta Próximamente",
    toolComingSoonBodyPrefix: "Estamos construyendo la lógica para",
    toolComingSoonBodySuffix: "Vuelve a consultarlo más tarde.",
    copy: "Copiar",
    clear: "Limpiar",
    cancel: "Cancelar",
    remove: "Eliminar",
    preview: "Vista previa",
    inputText: "Texto de entrada",
    output: "Salida",
    generatedText: "Texto generado",
    copyToClipboard: "Copiar al portapapeles",
    generate: "Generar",
    convert: "Convertir",
    from: "De",
    to: "A",
    autoDetect: "Detección automática",
    dropYourImageHere: "Suelta tu imagen aquí",
    orClickToBrowse: "o haz clic para elegir",
    converting: "Convirtiendo...",
    convertTo: "Convertir a",
    pleaseSelectImageFile: "Selecciona un archivo de imagen.",
    numberOfParagraphs: "Número de párrafos",
    wordsPerParagraph: "Palabras por párrafo",
    words: "Palabras",
    characters: "Caracteres",
    sentences: "Oraciones",
    paragraphs: "Párrafos",
    noSpaces: "Sin espacios",
    typeOrPasteTextHere: "Escribe o pega tu texto aquí...",
    enterYourTextHere: "Introduce tu texto aquí...",
    resizeSettings: "Ajustes de tamaño",
    widthPx: "Ancho (px)",
    heightPx: "Alto (px)",
    maintainAspectRatio: "Mantener proporción",
    quality: "Calidad",
    downloadResizedImage: "Descargar imagen redimensionada",
    uploadDifferentImage: "Subir otra imagen",
    clickToUploadImage: "Haz clic para subir una imagen",
    supportsJpgPng: "Compatible con JPG, PNG",
    compressionQuality: "Calidad de compresión",
    maximumCompression: "Compresión máxima (baja calidad)",
    minimumCompression: "Compresión mínima (alta calidad)",
    compressing: "Comprimiendo...",
    compressionSuccessful: "¡Compresión exitosa!",
    readyForDownload: "Tu imagen está lista para descargar.",
    originalSize: "Tamaño original",
    compressedSize: "Tamaño comprimido",
    totalReduction: "Reducción total",
    originalPreview: "Vista previa original",
    compressedPreview: "Vista previa comprimida",
    downloadCompressedImage: "Descargar imagen comprimida",
    aspectRatio: "Relación de aspecto",
    dimensions: "Dimensiones",
    xPosition: "Posición X",
    yPosition: "Posición Y",
    cropAndDownload: "Recortar y descargar",
    cancelOrNewImage: "Cancelar / Nueva imagen",
    cropArea: "Área de recorte",
    free: "Libre",
    square: "Cuadrado",
    uploadPdfToEdit: "Subir PDF para editar",
    clickToSelectOrDragPdfHere: "Haz clic para seleccionar o arrastra el PDF aquí",
    redirectingToPdfEditor: "Redirigiendo al editor PDF...",
  },
  fr: {
    loadingPdfTool: "Chargement de l'outil PDF...",
    loadingPdfEditor: "Chargement de l'éditeur PDF...",
    loadingVectorizer: "Chargement du vectoriseur...",
    toolComingSoonTitle: "Outil Bientôt Disponible",
    toolComingSoonBodyPrefix: "Nous construisons actuellement la logique pour",
    toolComingSoonBodySuffix: "Merci de revenir plus tard.",
    copy: "Copier",
    clear: "Effacer",
    cancel: "Annuler",
    remove: "Supprimer",
    preview: "Aperçu",
    inputText: "Texte d'entrée",
    output: "Sortie",
    generatedText: "Texte généré",
    copyToClipboard: "Copier dans le presse-papiers",
    generate: "Générer",
    convert: "Convertir",
    from: "De",
    to: "Vers",
    autoDetect: "Détection automatique",
    dropYourImageHere: "Déposez votre image ici",
    orClickToBrowse: "ou cliquez pour parcourir",
    converting: "Conversion en cours...",
    convertTo: "Convertir en",
    pleaseSelectImageFile: "Veuillez sélectionner une image.",
    numberOfParagraphs: "Nombre de paragraphes",
    wordsPerParagraph: "Mots par paragraphe",
    words: "Mots",
    characters: "Caractères",
    sentences: "Phrases",
    paragraphs: "Paragraphes",
    noSpaces: "Sans espaces",
    typeOrPasteTextHere: "Tapez ou collez votre texte ici...",
    enterYourTextHere: "Saisissez votre texte ici...",
    resizeSettings: "Paramètres de redimensionnement",
    widthPx: "Largeur (px)",
    heightPx: "Hauteur (px)",
    maintainAspectRatio: "Conserver les proportions",
    quality: "Qualité",
    downloadResizedImage: "Télécharger l'image redimensionnée",
    uploadDifferentImage: "Téléverser une autre image",
    clickToUploadImage: "Cliquez pour téléverser une image",
    supportsJpgPng: "Prend en charge JPG, PNG",
    compressionQuality: "Qualité de compression",
    maximumCompression: "Compression maximale (basse qualité)",
    minimumCompression: "Compression minimale (haute qualité)",
    compressing: "Compression en cours...",
    compressionSuccessful: "Compression réussie !",
    readyForDownload: "Votre image est prête à être téléchargée.",
    originalSize: "Taille d'origine",
    compressedSize: "Taille compressée",
    totalReduction: "Réduction totale",
    originalPreview: "Aperçu original",
    compressedPreview: "Aperçu compressé",
    downloadCompressedImage: "Télécharger l'image compressée",
    aspectRatio: "Ratio",
    dimensions: "Dimensions",
    xPosition: "Position X",
    yPosition: "Position Y",
    cropAndDownload: "Rogner et télécharger",
    cancelOrNewImage: "Annuler / Nouvelle image",
    cropArea: "Zone de recadrage",
    free: "Libre",
    square: "Carré",
    uploadPdfToEdit: "Téléverser un PDF à modifier",
    clickToSelectOrDragPdfHere: "Cliquez pour sélectionner ou déposez le PDF ici",
    redirectingToPdfEditor: "Redirection vers l'éditeur PDF...",
  },
  de: {
    loadingPdfTool: "PDF-Tool wird geladen...",
    loadingPdfEditor: "PDF-Editor wird geladen...",
    loadingVectorizer: "Vektorisierer wird geladen...",
    toolComingSoonTitle: "Tool Kommt Bald",
    toolComingSoonBodyPrefix: "Wir bauen derzeit die Logik für",
    toolComingSoonBodySuffix: "Bitte schaue später noch einmal vorbei.",
    copy: "Kopieren",
    clear: "Leeren",
    cancel: "Abbrechen",
    remove: "Entfernen",
    preview: "Vorschau",
    inputText: "Eingabetext",
    output: "Ausgabe",
    generatedText: "Generierter Text",
    copyToClipboard: "In die Zwischenablage kopieren",
    generate: "Generieren",
    convert: "Konvertieren",
    from: "Von",
    to: "Nach",
    autoDetect: "Automatisch erkennen",
    dropYourImageHere: "Bild hier ablegen",
    orClickToBrowse: "oder zum Auswählen klicken",
    converting: "Wird konvertiert...",
    convertTo: "Konvertieren zu",
    pleaseSelectImageFile: "Bitte wähle eine Bilddatei aus.",
    numberOfParagraphs: "Anzahl der Absätze",
    wordsPerParagraph: "Wörter pro Absatz",
    words: "Wörter",
    characters: "Zeichen",
    sentences: "Sätze",
    paragraphs: "Absätze",
    noSpaces: "Ohne Leerzeichen",
    typeOrPasteTextHere: "Text hier eingeben oder einfügen...",
    enterYourTextHere: "Text hier eingeben...",
    resizeSettings: "Resize-Einstellungen",
    widthPx: "Breite (px)",
    heightPx: "Höhe (px)",
    maintainAspectRatio: "Seitenverhältnis beibehalten",
    quality: "Qualität",
    downloadResizedImage: "Skaliertes Bild herunterladen",
    uploadDifferentImage: "Anderes Bild hochladen",
    clickToUploadImage: "Zum Hochladen klicken",
    supportsJpgPng: "Unterstützt JPG, PNG",
    compressionQuality: "Kompressionsqualität",
    maximumCompression: "Maximale Kompression (niedrige Qualität)",
    minimumCompression: "Minimale Kompression (hohe Qualität)",
    compressing: "Komprimiert...",
    compressionSuccessful: "Komprimierung erfolgreich!",
    readyForDownload: "Dein Bild ist zum Download bereit.",
    originalSize: "Originalgröße",
    compressedSize: "Komprimierte Größe",
    totalReduction: "Gesamtreduzierung",
    originalPreview: "Originalvorschau",
    compressedPreview: "Komprimierte Vorschau",
    downloadCompressedImage: "Komprimiertes Bild herunterladen",
    aspectRatio: "Seitenverhältnis",
    dimensions: "Abmessungen",
    xPosition: "X-Position",
    yPosition: "Y-Position",
    cropAndDownload: "Zuschneiden & Herunterladen",
    cancelOrNewImage: "Abbrechen / Neues Bild",
    cropArea: "Zuschneidebereich",
    free: "Frei",
    square: "Quadrat",
    uploadPdfToEdit: "PDF zum Bearbeiten hochladen",
    clickToSelectOrDragPdfHere: "Klicken oder PDF hierher ziehen",
    redirectingToPdfEditor: "Weiterleitung zum PDF-Editor...",
  },
  it: {
    loadingPdfTool: "Caricamento strumento PDF...",
    loadingPdfEditor: "Caricamento editor PDF...",
    loadingVectorizer: "Caricamento vectorizer...",
    toolComingSoonTitle: "Strumento in Arrivo",
    toolComingSoonBodyPrefix: "Stiamo costruendo la logica per",
    toolComingSoonBodySuffix: "Torna a controllare più tardi.",
    copy: "Copia",
    clear: "Cancella",
    cancel: "Annulla",
    remove: "Rimuovi",
    preview: "Anteprima",
    inputText: "Testo di input",
    output: "Output",
    generatedText: "Testo generato",
    copyToClipboard: "Copia negli appunti",
    generate: "Genera",
    convert: "Converti",
    from: "Da",
    to: "A",
    autoDetect: "Rilevamento automatico",
    dropYourImageHere: "Trascina qui la tua immagine",
    orClickToBrowse: "oppure clicca per scegliere",
    converting: "Conversione in corso...",
    convertTo: "Converti in",
    pleaseSelectImageFile: "Seleziona un file immagine.",
    numberOfParagraphs: "Numero di paragrafi",
    wordsPerParagraph: "Parole per paragrafo",
    words: "Parole",
    characters: "Caratteri",
    sentences: "Frasi",
    paragraphs: "Paragrafi",
    noSpaces: "Senza spazi",
    typeOrPasteTextHere: "Scrivi o incolla qui il tuo testo...",
    enterYourTextHere: "Inserisci qui il tuo testo...",
    resizeSettings: "Impostazioni ridimensionamento",
    widthPx: "Larghezza (px)",
    heightPx: "Altezza (px)",
    maintainAspectRatio: "Mantieni proporzioni",
    quality: "Qualità",
    downloadResizedImage: "Scarica immagine ridimensionata",
    uploadDifferentImage: "Carica un'altra immagine",
    clickToUploadImage: "Clicca per caricare un'immagine",
    supportsJpgPng: "Supporta JPG, PNG",
    compressionQuality: "Qualità compressione",
    maximumCompression: "Compressione massima (bassa qualità)",
    minimumCompression: "Compressione minima (alta qualità)",
    compressing: "Compressione in corso...",
    compressionSuccessful: "Compressione riuscita!",
    readyForDownload: "La tua immagine è pronta per il download.",
    originalSize: "Dimensione originale",
    compressedSize: "Dimensione compressa",
    totalReduction: "Riduzione totale",
    originalPreview: "Anteprima originale",
    compressedPreview: "Anteprima compressa",
    downloadCompressedImage: "Scarica immagine compressa",
    aspectRatio: "Rapporto d'aspetto",
    dimensions: "Dimensioni",
    xPosition: "Posizione X",
    yPosition: "Posizione Y",
    cropAndDownload: "Ritaglia e scarica",
    cancelOrNewImage: "Annulla / Nuova immagine",
    cropArea: "Area di ritaglio",
    free: "Libero",
    square: "Quadrato",
    uploadPdfToEdit: "Carica PDF da modificare",
    clickToSelectOrDragPdfHere: "Clicca per selezionare o trascina qui il PDF",
    redirectingToPdfEditor: "Reindirizzamento all'editor PDF...",
  },
  hu: {
    loadingPdfTool: "PDF eszköz betöltése...",
    loadingPdfEditor: "PDF szerkesztő betöltése...",
    loadingVectorizer: "Vectorizer betöltése...",
    toolComingSoonTitle: "Az Eszköz Hamarosan Érkezik",
    toolComingSoonBodyPrefix: "Jelenleg ezt a logikát építjük:",
    toolComingSoonBodySuffix: "Kérjük, nézz vissza később.",
    copy: "Másolás",
    clear: "Törlés",
    cancel: "Mégse",
    remove: "Eltávolítás",
    preview: "Előnézet",
    inputText: "Bemeneti szöveg",
    output: "Kimenet",
    generatedText: "Generált szöveg",
    copyToClipboard: "Másolás vágólapra",
    generate: "Generálás",
    convert: "Átalakítás",
    from: "Innen",
    to: "Ide",
    autoDetect: "Automatikus felismerés",
    dropYourImageHere: "Húzd ide a képet",
    orClickToBrowse: "vagy kattints a tallózáshoz",
    converting: "Átalakítás folyamatban...",
    convertTo: "Átalakítás erre",
    pleaseSelectImageFile: "Kérlek válassz képfájlt.",
    numberOfParagraphs: "Bekezdések száma",
    wordsPerParagraph: "Szavak bekezdésenként",
    words: "Szavak",
    characters: "Karakterek",
    sentences: "Mondatok",
    paragraphs: "Bekezdések",
    noSpaces: "Szóköz nélkül",
    typeOrPasteTextHere: "Írd be vagy illeszd be ide a szöveget...",
    enterYourTextHere: "Írd be ide a szöveget...",
    resizeSettings: "Átméretezési beállítások",
    widthPx: "Szélesség (px)",
    heightPx: "Magasság (px)",
    maintainAspectRatio: "Képarány megtartása",
    quality: "Minőség",
    downloadResizedImage: "Átméretezett kép letöltése",
    uploadDifferentImage: "Másik kép feltöltése",
    clickToUploadImage: "Kattints a kép feltöltéséhez",
    supportsJpgPng: "JPG, PNG támogatott",
    compressionQuality: "Tömörítési minőség",
    maximumCompression: "Maximális tömörítés (alacsony minőség)",
    minimumCompression: "Minimális tömörítés (magas minőség)",
    compressing: "Tömörítés...",
    compressionSuccessful: "Sikeres tömörítés!",
    readyForDownload: "A képed letölthető.",
    originalSize: "Eredeti méret",
    compressedSize: "Tömörített méret",
    totalReduction: "Teljes csökkenés",
    originalPreview: "Eredeti előnézet",
    compressedPreview: "Tömörített előnézet",
    downloadCompressedImage: "Tömörített kép letöltése",
    aspectRatio: "Képarány",
    dimensions: "Méretek",
    xPosition: "X pozíció",
    yPosition: "Y pozíció",
    cropAndDownload: "Kivágás és letöltés",
    cancelOrNewImage: "Mégse / Új kép",
    cropArea: "Kivágási terület",
    free: "Szabad",
    square: "Négyzet",
    uploadPdfToEdit: "PDF feltöltése szerkesztéshez",
    clickToSelectOrDragPdfHere: "Kattints a kiválasztáshoz vagy húzd ide a PDF-et",
    redirectingToPdfEditor: "Átirányítás a PDF szerkesztőhöz...",
  },
  ms: {
    loadingPdfTool: "Memuat alat PDF...",
    loadingPdfEditor: "Memuat editor PDF...",
    loadingVectorizer: "Memuat vectorizer...",
    toolComingSoonTitle: "Alat Akan Datang",
    toolComingSoonBodyPrefix: "Kami sedang membina logik untuk",
    toolComingSoonBodySuffix: "Sila semak semula kemudian.",
    copy: "Salin",
    clear: "Kosongkan",
    cancel: "Batal",
    remove: "Buang",
    preview: "Pratonton",
    inputText: "Teks input",
    output: "Output",
    generatedText: "Teks dijana",
    copyToClipboard: "Salin ke papan klip",
    generate: "Jana",
    convert: "Tukar",
    from: "Daripada",
    to: "Kepada",
    autoDetect: "Kesan automatik",
    dropYourImageHere: "Lepaskan imej anda di sini",
    orClickToBrowse: "atau klik untuk memilih",
    converting: "Sedang menukar...",
    convertTo: "Tukar kepada",
    pleaseSelectImageFile: "Sila pilih fail imej.",
    numberOfParagraphs: "Bilangan perenggan",
    wordsPerParagraph: "Perkataan setiap perenggan",
    words: "Perkataan",
    characters: "Aksara",
    sentences: "Ayat",
    paragraphs: "Perenggan",
    noSpaces: "Tanpa ruang",
    typeOrPasteTextHere: "Taip atau tampal teks anda di sini...",
    enterYourTextHere: "Masukkan teks anda di sini...",
    resizeSettings: "Tetapan ubah saiz",
    widthPx: "Lebar (px)",
    heightPx: "Tinggi (px)",
    maintainAspectRatio: "Kekalkan nisbah aspek",
    quality: "Kualiti",
    downloadResizedImage: "Muat turun imej diubah saiz",
    uploadDifferentImage: "Muat naik imej lain",
    clickToUploadImage: "Klik untuk memuat naik imej",
    supportsJpgPng: "Menyokong JPG, PNG",
    compressionQuality: "Kualiti mampatan",
    maximumCompression: "Mampatan maksimum (kualiti rendah)",
    minimumCompression: "Mampatan minimum (kualiti tinggi)",
    compressing: "Sedang memampatkan...",
    compressionSuccessful: "Mampatan berjaya!",
    readyForDownload: "Imej anda sedia untuk dimuat turun.",
    originalSize: "Saiz asal",
    compressedSize: "Saiz termampat",
    totalReduction: "Jumlah pengurangan",
    originalPreview: "Pratonton asal",
    compressedPreview: "Pratonton termampat",
    downloadCompressedImage: "Muat turun imej termampat",
    aspectRatio: "Nisbah aspek",
    dimensions: "Dimensi",
    xPosition: "Posisi X",
    yPosition: "Posisi Y",
    cropAndDownload: "Potong & Muat turun",
    cancelOrNewImage: "Batal / Imej baru",
    cropArea: "Kawasan potong",
    free: "Bebas",
    square: "Segi empat",
    uploadPdfToEdit: "Muat naik PDF untuk edit",
    clickToSelectOrDragPdfHere: "Klik untuk pilih atau seret PDF ke sini",
    redirectingToPdfEditor: "Mengalihkan ke editor PDF...",
  },
  nl: {
    loadingPdfTool: "PDF-tool laden...",
    loadingPdfEditor: "PDF-editor laden...",
    loadingVectorizer: "Vectorizer laden...",
    toolComingSoonTitle: "Tool Komt Binnenkort",
    toolComingSoonBodyPrefix: "We bouwen momenteel de logica voor",
    toolComingSoonBodySuffix: "Kom later nog eens terug.",
    copy: "Kopiëren",
    clear: "Wissen",
    cancel: "Annuleren",
    remove: "Verwijderen",
    preview: "Voorbeeld",
    inputText: "Invoertekst",
    output: "Uitvoer",
    generatedText: "Gegenereerde tekst",
    copyToClipboard: "Kopiëren naar klembord",
    generate: "Genereren",
    convert: "Converteren",
    from: "Van",
    to: "Naar",
    autoDetect: "Automatisch detecteren",
    dropYourImageHere: "Sleep je afbeelding hierheen",
    orClickToBrowse: "of klik om te kiezen",
    converting: "Converteren...",
    convertTo: "Converteren naar",
    pleaseSelectImageFile: "Selecteer een afbeeldingsbestand.",
    numberOfParagraphs: "Aantal alinea's",
    wordsPerParagraph: "Woorden per alinea",
    words: "Woorden",
    characters: "Tekens",
    sentences: "Zinnen",
    paragraphs: "Alinea's",
    noSpaces: "Geen spaties",
    typeOrPasteTextHere: "Typ of plak hier je tekst...",
    enterYourTextHere: "Voer hier je tekst in...",
    resizeSettings: "Instellingen voor formaat wijzigen",
    widthPx: "Breedte (px)",
    heightPx: "Hoogte (px)",
    maintainAspectRatio: "Beeldverhouding behouden",
    quality: "Kwaliteit",
    downloadResizedImage: "Aangepaste afbeelding downloaden",
    uploadDifferentImage: "Andere afbeelding uploaden",
    clickToUploadImage: "Klik om afbeelding te uploaden",
    supportsJpgPng: "Ondersteunt JPG, PNG",
    compressionQuality: "Compressiekwaliteit",
    maximumCompression: "Maximale compressie (lage kwaliteit)",
    minimumCompression: "Minimale compressie (hoge kwaliteit)",
    compressing: "Bezig met comprimeren...",
    compressionSuccessful: "Compressie gelukt!",
    readyForDownload: "Je afbeelding is klaar om te downloaden.",
    originalSize: "Originele grootte",
    compressedSize: "Gecomprimeerde grootte",
    totalReduction: "Totale reductie",
    originalPreview: "Origineel voorbeeld",
    compressedPreview: "Gecomprimeerd voorbeeld",
    downloadCompressedImage: "Gecomprimeerde afbeelding downloaden",
    aspectRatio: "Beeldverhouding",
    dimensions: "Afmetingen",
    xPosition: "X-positie",
    yPosition: "Y-positie",
    cropAndDownload: "Bijsnijden en downloaden",
    cancelOrNewImage: "Annuleren / Nieuwe afbeelding",
    cropArea: "Bijsnijdgebied",
    free: "Vrij",
    square: "Vierkant",
    uploadPdfToEdit: "PDF uploaden om te bewerken",
    clickToSelectOrDragPdfHere: "Klik om te kiezen of sleep PDF hierheen",
    redirectingToPdfEditor: "Doorsturen naar PDF-editor...",
  },
  pl: {
    loadingPdfTool: "Ładowanie narzędzia PDF...",
    loadingPdfEditor: "Ładowanie edytora PDF...",
    loadingVectorizer: "Ładowanie vectorizera...",
    toolComingSoonTitle: "Narzędzie Wkrótce",
    toolComingSoonBodyPrefix: "Obecnie tworzymy logikę dla",
    toolComingSoonBodySuffix: "Sprawdź ponownie później.",
    copy: "Kopiuj",
    clear: "Wyczyść",
    cancel: "Anuluj",
    remove: "Usuń",
    preview: "Podgląd",
    inputText: "Tekst wejściowy",
    output: "Wynik",
    generatedText: "Wygenerowany tekst",
    copyToClipboard: "Kopiuj do schowka",
    generate: "Generuj",
    convert: "Konwertuj",
    from: "Z",
    to: "Do",
    autoDetect: "Wykryj automatycznie",
    dropYourImageHere: "Upuść obraz tutaj",
    orClickToBrowse: "lub kliknij, aby wybrać",
    converting: "Konwertowanie...",
    convertTo: "Konwertuj do",
    pleaseSelectImageFile: "Wybierz plik obrazu.",
    numberOfParagraphs: "Liczba akapitów",
    wordsPerParagraph: "Słów na akapit",
    words: "Słowa",
    characters: "Znaki",
    sentences: "Zdania",
    paragraphs: "Akapity",
    noSpaces: "Bez spacji",
    typeOrPasteTextHere: "Wpisz lub wklej tutaj tekst...",
    enterYourTextHere: "Wpisz tutaj tekst...",
    resizeSettings: "Ustawienia zmiany rozmiaru",
    widthPx: "Szerokość (px)",
    heightPx: "Wysokość (px)",
    maintainAspectRatio: "Zachowaj proporcje",
    quality: "Jakość",
    downloadResizedImage: "Pobierz zmieniony obraz",
    uploadDifferentImage: "Prześlij inny obraz",
    clickToUploadImage: "Kliknij, aby przesłać obraz",
    supportsJpgPng: "Obsługuje JPG, PNG",
    compressionQuality: "Jakość kompresji",
    maximumCompression: "Maksymalna kompresja (niska jakość)",
    minimumCompression: "Minimalna kompresja (wysoka jakość)",
    compressing: "Kompresowanie...",
    compressionSuccessful: "Kompresja zakończona!",
    readyForDownload: "Twój obraz jest gotowy do pobrania.",
    originalSize: "Rozmiar oryginalny",
    compressedSize: "Rozmiar po kompresji",
    totalReduction: "Łączna redukcja",
    originalPreview: "Podgląd oryginału",
    compressedPreview: "Podgląd po kompresji",
    downloadCompressedImage: "Pobierz skompresowany obraz",
    aspectRatio: "Proporcje",
    dimensions: "Wymiary",
    xPosition: "Pozycja X",
    yPosition: "Pozycja Y",
    cropAndDownload: "Przytnij i pobierz",
    cancelOrNewImage: "Anuluj / Nowy obraz",
    cropArea: "Obszar kadrowania",
    free: "Dowolne",
    square: "Kwadrat",
    uploadPdfToEdit: "Prześlij PDF do edycji",
    clickToSelectOrDragPdfHere: "Kliknij, aby wybrać lub przeciągnij PDF tutaj",
    redirectingToPdfEditor: "Przekierowanie do edytora PDF...",
  },
  pt: {
    loadingPdfTool: "Carregando ferramenta PDF...",
    loadingPdfEditor: "Carregando editor PDF...",
    loadingVectorizer: "Carregando vectorizer...",
    toolComingSoonTitle: "Ferramenta em Breve",
    toolComingSoonBodyPrefix: "Estamos construindo a lógica para",
    toolComingSoonBodySuffix: "Volte mais tarde.",
    copy: "Copiar",
    clear: "Limpar",
    cancel: "Cancelar",
    remove: "Remover",
    preview: "Pré-visualização",
    inputText: "Texto de entrada",
    output: "Saída",
    generatedText: "Texto gerado",
    copyToClipboard: "Copiar para a área de transferência",
    generate: "Gerar",
    convert: "Converter",
    from: "De",
    to: "Para",
    autoDetect: "Detecção automática",
    dropYourImageHere: "Solte sua imagem aqui",
    orClickToBrowse: "ou clique para escolher",
    converting: "Convertendo...",
    convertTo: "Converter para",
    pleaseSelectImageFile: "Selecione um arquivo de imagem.",
    numberOfParagraphs: "Número de parágrafos",
    wordsPerParagraph: "Palavras por parágrafo",
    words: "Palavras",
    characters: "Caracteres",
    sentences: "Frases",
    paragraphs: "Parágrafos",
    noSpaces: "Sem espaços",
    typeOrPasteTextHere: "Digite ou cole seu texto aqui...",
    enterYourTextHere: "Digite seu texto aqui...",
    resizeSettings: "Configurações de redimensionamento",
    widthPx: "Largura (px)",
    heightPx: "Altura (px)",
    maintainAspectRatio: "Manter proporção",
    quality: "Qualidade",
    downloadResizedImage: "Baixar imagem redimensionada",
    uploadDifferentImage: "Enviar outra imagem",
    clickToUploadImage: "Clique para enviar imagem",
    supportsJpgPng: "Suporta JPG, PNG",
    compressionQuality: "Qualidade de compressão",
    maximumCompression: "Compressão máxima (baixa qualidade)",
    minimumCompression: "Compressão mínima (alta qualidade)",
    compressing: "Comprimindo...",
    compressionSuccessful: "Compressão concluída!",
    readyForDownload: "Sua imagem está pronta para download.",
    originalSize: "Tamanho original",
    compressedSize: "Tamanho comprimido",
    totalReduction: "Redução total",
    originalPreview: "Prévia original",
    compressedPreview: "Prévia comprimida",
    downloadCompressedImage: "Baixar imagem comprimida",
    aspectRatio: "Proporção",
    dimensions: "Dimensões",
    xPosition: "Posição X",
    yPosition: "Posição Y",
    cropAndDownload: "Cortar e baixar",
    cancelOrNewImage: "Cancelar / Nova imagem",
    cropArea: "Área de corte",
    free: "Livre",
    square: "Quadrado",
    uploadPdfToEdit: "Enviar PDF para editar",
    clickToSelectOrDragPdfHere: "Clique para selecionar ou arraste o PDF aqui",
    redirectingToPdfEditor: "Redirecionando para o editor PDF...",
  },
  th: {
    loadingPdfTool: "กำลังโหลดเครื่องมือ PDF...",
    loadingPdfEditor: "กำลังโหลดตัวแก้ไข PDF...",
    loadingVectorizer: "กำลังโหลด vectorizer...",
    toolComingSoonTitle: "เครื่องมือกำลังมา",
    toolComingSoonBodyPrefix: "เรากำลังสร้าง logic สำหรับ",
    toolComingSoonBodySuffix: "กรุณากลับมาตรวจสอบอีกครั้งภายหลัง",
    copy: "คัดลอก",
    clear: "ล้าง",
    cancel: "ยกเลิก",
    remove: "ลบ",
    preview: "ตัวอย่าง",
    inputText: "ข้อความนำเข้า",
    output: "ผลลัพธ์",
    generatedText: "ข้อความที่สร้าง",
    copyToClipboard: "คัดลอกไปยังคลิปบอร์ด",
    generate: "สร้าง",
    convert: "แปลง",
    from: "จาก",
    to: "เป็น",
    autoDetect: "ตรวจจับอัตโนมัติ",
    dropYourImageHere: "วางรูปของคุณที่นี่",
    orClickToBrowse: "หรือคลิกเพื่อเลือก",
    converting: "กำลังแปลง...",
    convertTo: "แปลงเป็น",
    pleaseSelectImageFile: "โปรดเลือกไฟล์รูปภาพ",
    numberOfParagraphs: "จำนวนย่อหน้า",
    wordsPerParagraph: "คำต่อย่อหน้า",
    words: "คำ",
    characters: "อักขระ",
    sentences: "ประโยค",
    paragraphs: "ย่อหน้า",
    noSpaces: "ไม่มีช่องว่าง",
    typeOrPasteTextHere: "พิมพ์หรือวางข้อความของคุณที่นี่...",
    enterYourTextHere: "ป้อนข้อความของคุณที่นี่...",
    resizeSettings: "การตั้งค่าปรับขนาด",
    widthPx: "ความกว้าง (px)",
    heightPx: "ความสูง (px)",
    maintainAspectRatio: "รักษาอัตราส่วนภาพ",
    quality: "คุณภาพ",
    downloadResizedImage: "ดาวน์โหลดภาพที่ปรับขนาดแล้ว",
    uploadDifferentImage: "อัปโหลดภาพอื่น",
    clickToUploadImage: "คลิกเพื่ออัปโหลดภาพ",
    supportsJpgPng: "รองรับ JPG, PNG",
    compressionQuality: "คุณภาพการบีบอัด",
    maximumCompression: "บีบอัดสูงสุด (คุณภาพต่ำ)",
    minimumCompression: "บีบอัดต่ำสุด (คุณภาพสูง)",
    compressing: "กำลังบีบอัด...",
    compressionSuccessful: "บีบอัดสำเร็จ!",
    readyForDownload: "รูปของคุณพร้อมดาวน์โหลดแล้ว",
    originalSize: "ขนาดต้นฉบับ",
    compressedSize: "ขนาดหลังบีบอัด",
    totalReduction: "ลดลงทั้งหมด",
    originalPreview: "ตัวอย่างต้นฉบับ",
    compressedPreview: "ตัวอย่างหลังบีบอัด",
    downloadCompressedImage: "ดาวน์โหลดภาพที่บีบอัดแล้ว",
    aspectRatio: "อัตราส่วนภาพ",
    dimensions: "ขนาด",
    xPosition: "ตำแหน่ง X",
    yPosition: "ตำแหน่ง Y",
    cropAndDownload: "ครอปและดาวน์โหลด",
    cancelOrNewImage: "ยกเลิก / ภาพใหม่",
    cropArea: "พื้นที่ครอป",
    free: "อิสระ",
    square: "สี่เหลี่ยมจัตุรัส",
    uploadPdfToEdit: "อัปโหลด PDF เพื่อแก้ไข",
    clickToSelectOrDragPdfHere: "คลิกเพื่อเลือกหรือลาก PDF มาที่นี่",
    redirectingToPdfEditor: "กำลังเปลี่ยนไปยังตัวแก้ไข PDF...",
  },
  tr: {
    loadingPdfTool: "PDF aracı yükleniyor...",
    loadingPdfEditor: "PDF düzenleyici yükleniyor...",
    loadingVectorizer: "Vectorizer yükleniyor...",
    toolComingSoonTitle: "Araç Çok Yakında",
    toolComingSoonBodyPrefix: "Şu anda şu araç için mantığı geliştiriyoruz:",
    toolComingSoonBodySuffix: "Lütfen daha sonra tekrar kontrol edin.",
    copy: "Kopyala",
    clear: "Temizle",
    cancel: "İptal",
    remove: "Kaldır",
    preview: "Önizleme",
    inputText: "Giriş metni",
    output: "Çıktı",
    generatedText: "Oluşturulan metin",
    copyToClipboard: "Panoya kopyala",
    generate: "Oluştur",
    convert: "Dönüştür",
    from: "Şundan",
    to: "Şuna",
    autoDetect: "Otomatik algıla",
    dropYourImageHere: "Görselinizi buraya bırakın",
    orClickToBrowse: "veya seçmek için tıklayın",
    converting: "Dönüştürülüyor...",
    convertTo: "Şuna dönüştür",
    pleaseSelectImageFile: "Lütfen bir görsel dosyası seçin.",
    numberOfParagraphs: "Paragraf sayısı",
    wordsPerParagraph: "Paragraf başına kelime",
    words: "Kelime",
    characters: "Karakter",
    sentences: "Cümle",
    paragraphs: "Paragraf",
    noSpaces: "Boşluksuz",
    typeOrPasteTextHere: "Metninizi buraya yazın veya yapıştırın...",
    enterYourTextHere: "Metninizi buraya girin...",
    resizeSettings: "Yeniden boyutlandırma ayarları",
    widthPx: "Genişlik (px)",
    heightPx: "Yükseklik (px)",
    maintainAspectRatio: "En boy oranını koru",
    quality: "Kalite",
    downloadResizedImage: "Yeniden boyutlandırılmış görseli indir",
    uploadDifferentImage: "Farklı görsel yükle",
    clickToUploadImage: "Görsel yüklemek için tıklayın",
    supportsJpgPng: "JPG, PNG destekler",
    compressionQuality: "Sıkıştırma kalitesi",
    maximumCompression: "Maksimum sıkıştırma (düşük kalite)",
    minimumCompression: "Minimum sıkıştırma (yüksek kalite)",
    compressing: "Sıkıştırılıyor...",
    compressionSuccessful: "Sıkıştırma başarılı!",
    readyForDownload: "Görseliniz indirilmeye hazır.",
    originalSize: "Orijinal boyut",
    compressedSize: "Sıkıştırılmış boyut",
    totalReduction: "Toplam küçülme",
    originalPreview: "Orijinal önizleme",
    compressedPreview: "Sıkıştırılmış önizleme",
    downloadCompressedImage: "Sıkıştırılmış görseli indir",
    aspectRatio: "En boy oranı",
    dimensions: "Boyutlar",
    xPosition: "X konumu",
    yPosition: "Y konumu",
    cropAndDownload: "Kırp ve indir",
    cancelOrNewImage: "İptal / Yeni görsel",
    cropArea: "Kırpma alanı",
    free: "Serbest",
    square: "Kare",
    uploadPdfToEdit: "Düzenlemek için PDF yükle",
    clickToSelectOrDragPdfHere: "Seçmek için tıklayın veya PDF'i buraya sürükleyin",
    redirectingToPdfEditor: "PDF düzenleyiciye yönlendiriliyor...",
  },
  el: {
    loadingPdfTool: "Φόρτωση εργαλείου PDF...",
    loadingPdfEditor: "Φόρτωση επεξεργαστή PDF...",
    loadingVectorizer: "Φόρτωση vectorizer...",
    toolComingSoonTitle: "Το Εργαλείο Έρχεται Σύντομα",
    toolComingSoonBodyPrefix: "Αυτή τη στιγμή φτιάχνουμε τη λογική για",
    toolComingSoonBodySuffix: "Επιστρέψτε αργότερα.",
    copy: "Αντιγραφή",
    clear: "Καθαρισμός",
    cancel: "Ακύρωση",
    remove: "Αφαίρεση",
    preview: "Προεπισκόπηση",
    inputText: "Κείμενο εισόδου",
    output: "Έξοδος",
    generatedText: "Παραγόμενο κείμενο",
    copyToClipboard: "Αντιγραφή στο πρόχειρο",
    generate: "Δημιουργία",
    convert: "Μετατροπή",
    from: "Από",
    to: "Σε",
    autoDetect: "Αυτόματη ανίχνευση",
    dropYourImageHere: "Σύρετε την εικόνα εδώ",
    orClickToBrowse: "ή κάντε κλικ για επιλογή",
    converting: "Γίνεται μετατροπή...",
    convertTo: "Μετατροπή σε",
    pleaseSelectImageFile: "Επιλέξτε ένα αρχείο εικόνας.",
    numberOfParagraphs: "Αριθμός παραγράφων",
    wordsPerParagraph: "Λέξεις ανά παράγραφο",
    words: "Λέξεις",
    characters: "Χαρακτήρες",
    sentences: "Προτάσεις",
    paragraphs: "Παράγραφοι",
    noSpaces: "Χωρίς κενά",
    typeOrPasteTextHere: "Πληκτρολογήστε ή επικολλήστε το κείμενό σας εδώ...",
    enterYourTextHere: "Εισάγετε το κείμενό σας εδώ...",
    resizeSettings: "Ρυθμίσεις αλλαγής μεγέθους",
    widthPx: "Πλάτος (px)",
    heightPx: "Ύψος (px)",
    maintainAspectRatio: "Διατήρηση αναλογίας",
    quality: "Ποιότητα",
    downloadResizedImage: "Λήψη εικόνας με νέο μέγεθος",
    uploadDifferentImage: "Μεταφόρτωση άλλης εικόνας",
    clickToUploadImage: "Κάντε κλικ για μεταφόρτωση εικόνας",
    supportsJpgPng: "Υποστηρίζει JPG, PNG",
    compressionQuality: "Ποιότητα συμπίεσης",
    maximumCompression: "Μέγιστη συμπίεση (χαμηλή ποιότητα)",
    minimumCompression: "Ελάχιστη συμπίεση (υψηλή ποιότητα)",
    compressing: "Γίνεται συμπίεση...",
    compressionSuccessful: "Η συμπίεση ολοκληρώθηκε!",
    readyForDownload: "Η εικόνα σας είναι έτοιμη για λήψη.",
    originalSize: "Αρχικό μέγεθος",
    compressedSize: "Συμπιεσμένο μέγεθος",
    totalReduction: "Συνολική μείωση",
    originalPreview: "Αρχική προεπισκόπηση",
    compressedPreview: "Συμπιεσμένη προεπισκόπηση",
    downloadCompressedImage: "Λήψη συμπιεσμένης εικόνας",
    aspectRatio: "Αναλογία",
    dimensions: "Διαστάσεις",
    xPosition: "Θέση X",
    yPosition: "Θέση Y",
    cropAndDownload: "Περικοπή και λήψη",
    cancelOrNewImage: "Ακύρωση / Νέα εικόνα",
    cropArea: "Περιοχή περικοπής",
    free: "Ελεύθερο",
    square: "Τετράγωνο",
    uploadPdfToEdit: "Μεταφόρτωση PDF για επεξεργασία",
    clickToSelectOrDragPdfHere: "Κάντε κλικ για επιλογή ή σύρετε το PDF εδώ",
    redirectingToPdfEditor: "Ανακατεύθυνση στον επεξεργαστή PDF...",
  },
  uk: {
    loadingPdfTool: "Завантаження PDF-інструмента...",
    loadingPdfEditor: "Завантаження PDF-редактора...",
    loadingVectorizer: "Завантаження vectorizer...",
    toolComingSoonTitle: "Інструмент Незабаром",
    toolComingSoonBodyPrefix: "Зараз ми створюємо логіку для",
    toolComingSoonBodySuffix: "Будь ласка, поверніться пізніше.",
    copy: "Копіювати",
    clear: "Очистити",
    cancel: "Скасувати",
    remove: "Видалити",
    preview: "Попередній перегляд",
    inputText: "Вхідний текст",
    output: "Результат",
    generatedText: "Згенерований текст",
    copyToClipboard: "Копіювати в буфер",
    generate: "Згенерувати",
    convert: "Конвертувати",
    from: "З",
    to: "У",
    autoDetect: "Автовизначення",
    dropYourImageHere: "Перетягніть зображення сюди",
    orClickToBrowse: "або натисніть, щоб вибрати",
    converting: "Конвертація...",
    convertTo: "Конвертувати в",
    pleaseSelectImageFile: "Будь ласка, виберіть зображення.",
    numberOfParagraphs: "Кількість абзаців",
    wordsPerParagraph: "Слів в абзаці",
    words: "Слова",
    characters: "Символи",
    sentences: "Речення",
    paragraphs: "Абзаци",
    noSpaces: "Без пробілів",
    typeOrPasteTextHere: "Введіть або вставте текст тут...",
    enterYourTextHere: "Введіть текст тут...",
    resizeSettings: "Налаштування розміру",
    widthPx: "Ширина (px)",
    heightPx: "Висота (px)",
    maintainAspectRatio: "Зберігати пропорції",
    quality: "Якість",
    downloadResizedImage: "Завантажити змінене зображення",
    uploadDifferentImage: "Завантажити інше зображення",
    clickToUploadImage: "Натисніть, щоб завантажити зображення",
    supportsJpgPng: "Підтримує JPG, PNG",
    compressionQuality: "Якість стиснення",
    maximumCompression: "Максимальне стиснення (низька якість)",
    minimumCompression: "Мінімальне стиснення (висока якість)",
    compressing: "Стиснення...",
    compressionSuccessful: "Стиснення успішне!",
    readyForDownload: "Ваше зображення готове до завантаження.",
    originalSize: "Початковий розмір",
    compressedSize: "Стиснений розмір",
    totalReduction: "Загальне зменшення",
    originalPreview: "Початковий перегляд",
    compressedPreview: "Стиснений перегляд",
    downloadCompressedImage: "Завантажити стиснене зображення",
    aspectRatio: "Співвідношення сторін",
    dimensions: "Розміри",
    xPosition: "Позиція X",
    yPosition: "Позиція Y",
    cropAndDownload: "Обрізати і завантажити",
    cancelOrNewImage: "Скасувати / Нове зображення",
    cropArea: "Область обрізки",
    free: "Вільно",
    square: "Квадрат",
    uploadPdfToEdit: "Завантажити PDF для редагування",
    clickToSelectOrDragPdfHere: "Натисніть для вибору або перетягніть PDF сюди",
    redirectingToPdfEditor: "Перенаправлення до PDF-редактора...",
  },
  ru: {
    loadingPdfTool: "Загрузка PDF-инструмента...",
    loadingPdfEditor: "Загрузка PDF-редактора...",
    loadingVectorizer: "Загрузка vectorizer...",
    toolComingSoonTitle: "Инструмент Скоро Появится",
    toolComingSoonBodyPrefix: "Сейчас мы создаем логику для",
    toolComingSoonBodySuffix: "Пожалуйста, зайдите позже.",
    copy: "Копировать",
    clear: "Очистить",
    cancel: "Отмена",
    remove: "Удалить",
    preview: "Предпросмотр",
    inputText: "Входной текст",
    output: "Результат",
    generatedText: "Сгенерированный текст",
    copyToClipboard: "Копировать в буфер",
    generate: "Сгенерировать",
    convert: "Преобразовать",
    from: "Из",
    to: "В",
    autoDetect: "Автоопределение",
    dropYourImageHere: "Перетащите изображение сюда",
    orClickToBrowse: "или нажмите, чтобы выбрать",
    converting: "Преобразование...",
    convertTo: "Преобразовать в",
    pleaseSelectImageFile: "Пожалуйста, выберите изображение.",
    numberOfParagraphs: "Количество абзацев",
    wordsPerParagraph: "Слов в абзаце",
    words: "Слова",
    characters: "Символы",
    sentences: "Предложения",
    paragraphs: "Абзацы",
    noSpaces: "Без пробелов",
    typeOrPasteTextHere: "Введите или вставьте текст сюда...",
    enterYourTextHere: "Введите текст сюда...",
    resizeSettings: "Настройки размера",
    widthPx: "Ширина (px)",
    heightPx: "Высота (px)",
    maintainAspectRatio: "Сохранять пропорции",
    quality: "Качество",
    downloadResizedImage: "Скачать измененное изображение",
    uploadDifferentImage: "Загрузить другое изображение",
    clickToUploadImage: "Нажмите, чтобы загрузить изображение",
    supportsJpgPng: "Поддерживает JPG, PNG",
    compressionQuality: "Качество сжатия",
    maximumCompression: "Максимальное сжатие (низкое качество)",
    minimumCompression: "Минимальное сжатие (высокое качество)",
    compressing: "Сжатие...",
    compressionSuccessful: "Сжатие завершено!",
    readyForDownload: "Ваше изображение готово к загрузке.",
    originalSize: "Исходный размер",
    compressedSize: "Размер после сжатия",
    totalReduction: "Общее уменьшение",
    originalPreview: "Исходный просмотр",
    compressedPreview: "Сжатый просмотр",
    downloadCompressedImage: "Скачать сжатое изображение",
    aspectRatio: "Соотношение сторон",
    dimensions: "Размеры",
    xPosition: "Позиция X",
    yPosition: "Позиция Y",
    cropAndDownload: "Обрезать и скачать",
    cancelOrNewImage: "Отмена / Новое изображение",
    cropArea: "Область обрезки",
    free: "Свободно",
    square: "Квадрат",
    uploadPdfToEdit: "Загрузить PDF для редактирования",
    clickToSelectOrDragPdfHere: "Нажмите для выбора или перетащите PDF сюда",
    redirectingToPdfEditor: "Переход к PDF-редактору...",
  },
  ar: {
    loadingPdfTool: "جارٍ تحميل أداة PDF...",
    loadingPdfEditor: "جارٍ تحميل محرر PDF...",
    loadingVectorizer: "جارٍ تحميل vectorizer...",
    toolComingSoonTitle: "الأداة قريبًا",
    toolComingSoonBodyPrefix: "نحن نبني الآن المنطق الخاص بـ",
    toolComingSoonBodySuffix: "يرجى العودة لاحقًا.",
    copy: "نسخ",
    clear: "مسح",
    cancel: "إلغاء",
    remove: "إزالة",
    preview: "معاينة",
    inputText: "النص المدخل",
    output: "النتيجة",
    generatedText: "النص الناتج",
    copyToClipboard: "نسخ إلى الحافظة",
    generate: "إنشاء",
    convert: "تحويل",
    from: "من",
    to: "إلى",
    autoDetect: "اكتشاف تلقائي",
    dropYourImageHere: "أفلت الصورة هنا",
    orClickToBrowse: "أو انقر للاختيار",
    converting: "جارٍ التحويل...",
    convertTo: "تحويل إلى",
    pleaseSelectImageFile: "يرجى اختيار ملف صورة.",
    numberOfParagraphs: "عدد الفقرات",
    wordsPerParagraph: "الكلمات لكل فقرة",
    words: "الكلمات",
    characters: "الأحرف",
    sentences: "الجمل",
    paragraphs: "الفقرات",
    noSpaces: "بدون مسافات",
    typeOrPasteTextHere: "اكتب النص هنا أو الصقه...",
    enterYourTextHere: "أدخل النص هنا...",
    resizeSettings: "إعدادات تغيير الحجم",
    widthPx: "العرض (px)",
    heightPx: "الارتفاع (px)",
    maintainAspectRatio: "الحفاظ على النسبة",
    quality: "الجودة",
    downloadResizedImage: "تنزيل الصورة بعد التغيير",
    uploadDifferentImage: "رفع صورة أخرى",
    clickToUploadImage: "انقر لرفع صورة",
    supportsJpgPng: "يدعم JPG و PNG",
    compressionQuality: "جودة الضغط",
    maximumCompression: "أقصى ضغط (جودة منخفضة)",
    minimumCompression: "أقل ضغط (جودة عالية)",
    compressing: "جارٍ الضغط...",
    compressionSuccessful: "تم الضغط بنجاح!",
    readyForDownload: "صورتك جاهزة للتنزيل.",
    originalSize: "الحجم الأصلي",
    compressedSize: "الحجم بعد الضغط",
    totalReduction: "إجمالي التخفيض",
    originalPreview: "المعاينة الأصلية",
    compressedPreview: "المعاينة المضغوطة",
    downloadCompressedImage: "تنزيل الصورة المضغوطة",
    aspectRatio: "نسبة الأبعاد",
    dimensions: "الأبعاد",
    xPosition: "موضع X",
    yPosition: "موضع Y",
    cropAndDownload: "قص وتنزيل",
    cancelOrNewImage: "إلغاء / صورة جديدة",
    cropArea: "منطقة القص",
    free: "حر",
    square: "مربع",
    uploadPdfToEdit: "رفع PDF للتعديل",
    clickToSelectOrDragPdfHere: "انقر للاختيار أو اسحب ملف PDF هنا",
    redirectingToPdfEditor: "جارٍ التحويل إلى محرر PDF...",
  },
  ko: {
    loadingPdfTool: "PDF 도구를 불러오는 중...",
    loadingPdfEditor: "PDF 편집기를 불러오는 중...",
    loadingVectorizer: "vectorizer를 불러오는 중...",
    toolComingSoonTitle: "도구 준비 중",
    toolComingSoonBodyPrefix: "현재 다음 도구의 로직을 만들고 있습니다:",
    toolComingSoonBodySuffix: "나중에 다시 확인해 주세요.",
    copy: "복사",
    clear: "지우기",
    cancel: "취소",
    remove: "제거",
    preview: "미리보기",
    inputText: "입력 텍스트",
    output: "출력",
    generatedText: "생성된 텍스트",
    copyToClipboard: "클립보드에 복사",
    generate: "생성",
    convert: "변환",
    from: "원본",
    to: "대상",
    autoDetect: "자동 감지",
    dropYourImageHere: "이미지를 여기에 놓으세요",
    orClickToBrowse: "또는 클릭해서 선택",
    converting: "변환 중...",
    convertTo: "다음 형식으로 변환",
    pleaseSelectImageFile: "이미지 파일을 선택해 주세요.",
    numberOfParagraphs: "문단 수",
    wordsPerParagraph: "문단당 단어 수",
    words: "단어",
    characters: "문자",
    sentences: "문장",
    paragraphs: "문단",
    noSpaces: "공백 제외",
    typeOrPasteTextHere: "여기에 텍스트를 입력하거나 붙여넣으세요...",
    enterYourTextHere: "여기에 텍스트를 입력하세요...",
    resizeSettings: "리사이즈 설정",
    widthPx: "너비 (px)",
    heightPx: "높이 (px)",
    maintainAspectRatio: "비율 유지",
    quality: "품질",
    downloadResizedImage: "크기 변경 이미지 다운로드",
    uploadDifferentImage: "다른 이미지 업로드",
    clickToUploadImage: "이미지를 업로드하려면 클릭",
    supportsJpgPng: "JPG, PNG 지원",
    compressionQuality: "압축 품질",
    maximumCompression: "최대 압축 (낮은 품질)",
    minimumCompression: "최소 압축 (높은 품질)",
    compressing: "압축 중...",
    compressionSuccessful: "압축 완료!",
    readyForDownload: "이미지가 다운로드 준비되었습니다.",
    originalSize: "원본 크기",
    compressedSize: "압축 후 크기",
    totalReduction: "총 감소율",
    originalPreview: "원본 미리보기",
    compressedPreview: "압축 미리보기",
    downloadCompressedImage: "압축 이미지 다운로드",
    aspectRatio: "종횡비",
    dimensions: "크기",
    xPosition: "X 위치",
    yPosition: "Y 위치",
    cropAndDownload: "자르기 및 다운로드",
    cancelOrNewImage: "취소 / 새 이미지",
    cropArea: "자르기 영역",
    free: "자유",
    square: "정사각형",
    uploadPdfToEdit: "편집할 PDF 업로드",
    clickToSelectOrDragPdfHere: "클릭하여 선택하거나 PDF를 여기로 드래그하세요",
    redirectingToPdfEditor: "PDF 편집기로 이동 중...",
  },
  ja: {
    loadingPdfTool: "PDFツールを読み込み中...",
    loadingPdfEditor: "PDFエディターを読み込み中...",
    loadingVectorizer: "vectorizerを読み込み中...",
    toolComingSoonTitle: "ツール準備中",
    toolComingSoonBodyPrefix: "現在このツールのロジックを構築しています:",
    toolComingSoonBodySuffix: "後でもう一度ご確認ください。",
    copy: "コピー",
    clear: "クリア",
    cancel: "キャンセル",
    remove: "削除",
    preview: "プレビュー",
    inputText: "入力テキスト",
    output: "出力",
    generatedText: "生成されたテキスト",
    copyToClipboard: "クリップボードにコピー",
    generate: "生成",
    convert: "変換",
    from: "変換元",
    to: "変換先",
    autoDetect: "自動検出",
    dropYourImageHere: "ここに画像をドロップ",
    orClickToBrowse: "またはクリックして選択",
    converting: "変換中...",
    convertTo: "次に変換",
    pleaseSelectImageFile: "画像ファイルを選択してください。",
    numberOfParagraphs: "段落数",
    wordsPerParagraph: "段落ごとの単語数",
    words: "単語",
    characters: "文字",
    sentences: "文",
    paragraphs: "段落",
    noSpaces: "空白を除く",
    typeOrPasteTextHere: "ここにテキストを入力または貼り付け...",
    enterYourTextHere: "ここにテキストを入力...",
    resizeSettings: "サイズ変更設定",
    widthPx: "幅 (px)",
    heightPx: "高さ (px)",
    maintainAspectRatio: "縦横比を維持",
    quality: "品質",
    downloadResizedImage: "サイズ変更後の画像をダウンロード",
    uploadDifferentImage: "別の画像をアップロード",
    clickToUploadImage: "クリックして画像をアップロード",
    supportsJpgPng: "JPG、PNGに対応",
    compressionQuality: "圧縮品質",
    maximumCompression: "最大圧縮（低品質）",
    minimumCompression: "最小圧縮（高品質）",
    compressing: "圧縮中...",
    compressionSuccessful: "圧縮が完了しました！",
    readyForDownload: "画像をダウンロードできます。",
    originalSize: "元のサイズ",
    compressedSize: "圧縮後サイズ",
    totalReduction: "削減率",
    originalPreview: "元のプレビュー",
    compressedPreview: "圧縮後プレビュー",
    downloadCompressedImage: "圧縮画像をダウンロード",
    aspectRatio: "縦横比",
    dimensions: "サイズ",
    xPosition: "X位置",
    yPosition: "Y位置",
    cropAndDownload: "切り抜いてダウンロード",
    cancelOrNewImage: "キャンセル / 新しい画像",
    cropArea: "切り抜き範囲",
    free: "自由",
    square: "正方形",
    uploadPdfToEdit: "編集するPDFをアップロード",
    clickToSelectOrDragPdfHere: "クリックして選択、またはPDFをここにドラッグ",
    redirectingToPdfEditor: "PDFエディターへ移動中...",
  },
  ro: {
    loadingPdfTool: "Se încarcă unealta PDF...",
    loadingPdfEditor: "Se încarcă editorul PDF...",
    loadingVectorizer: "Se încarcă vectorizer...",
    toolComingSoonTitle: "Unealta Vine Curând",
    toolComingSoonBodyPrefix: "În prezent construim logica pentru",
    toolComingSoonBodySuffix: "Revino mai târziu.",
    copy: "Copiază",
    clear: "Curăță",
    cancel: "Anulează",
    remove: "Șterge",
    preview: "Previzualizare",
    inputText: "Text de intrare",
    output: "Rezultat",
    generatedText: "Text generat",
    copyToClipboard: "Copiază în clipboard",
    generate: "Generează",
    convert: "Convertește",
    from: "Din",
    to: "În",
    autoDetect: "Detectare automată",
    dropYourImageHere: "Trage imaginea aici",
    orClickToBrowse: "sau fă clic pentru a alege",
    converting: "Se convertește...",
    convertTo: "Convertește în",
    pleaseSelectImageFile: "Te rugăm să alegi un fișier imagine.",
    numberOfParagraphs: "Număr de paragrafe",
    wordsPerParagraph: "Cuvinte pe paragraf",
    words: "Cuvinte",
    characters: "Caractere",
    sentences: "Propoziții",
    paragraphs: "Paragrafe",
    noSpaces: "Fără spații",
    typeOrPasteTextHere: "Scrie sau lipește textul aici...",
    enterYourTextHere: "Introdu textul aici...",
    resizeSettings: "Setări redimensionare",
    widthPx: "Lățime (px)",
    heightPx: "Înălțime (px)",
    maintainAspectRatio: "Păstrează proporțiile",
    quality: "Calitate",
    downloadResizedImage: "Descarcă imaginea redimensionată",
    uploadDifferentImage: "Încarcă altă imagine",
    clickToUploadImage: "Fă clic pentru a încărca o imagine",
    supportsJpgPng: "Acceptă JPG, PNG",
    compressionQuality: "Calitatea compresiei",
    maximumCompression: "Compresie maximă (calitate scăzută)",
    minimumCompression: "Compresie minimă (calitate ridicată)",
    compressing: "Se comprimă...",
    compressionSuccessful: "Compresie reușită!",
    readyForDownload: "Imaginea este gata pentru descărcare.",
    originalSize: "Dimensiune originală",
    compressedSize: "Dimensiune comprimată",
    totalReduction: "Reducere totală",
    originalPreview: "Previzualizare originală",
    compressedPreview: "Previzualizare comprimată",
    downloadCompressedImage: "Descarcă imaginea comprimată",
    aspectRatio: "Raport de aspect",
    dimensions: "Dimensiuni",
    xPosition: "Poziție X",
    yPosition: "Poziție Y",
    cropAndDownload: "Decupează și descarcă",
    cancelOrNewImage: "Anulează / Imagine nouă",
    cropArea: "Zona de decupare",
    free: "Liber",
    square: "Pătrat",
    uploadPdfToEdit: "Încarcă PDF pentru editare",
    clickToSelectOrDragPdfHere: "Fă clic pentru a alege sau trage PDF-ul aici",
    redirectingToPdfEditor: "Redirecționare către editorul PDF...",
  },
};

export function getToolUiCopy(locale: Locale) {
  return copy[locale] ?? copy.en;
}
